import {getAllSelector, isAllChecked, unwrapOptions} from './MultiUtils'

export default function MultiSelectionRenderer (placeholder) {
  return function (optionsObj) {
    const options = unwrapOptions(optionsObj)
    const allSelector = getAllSelector(options)
    let text
    if (isAllChecked(options) && allSelector) {
      text = allSelector.label
    } else {
      let checkedOptions = options.filter(option => option.checked)
      const len = checkedOptions.length
      if (len === 0) {
        text = placeholder
      } else {
        text = checkedOptions[0].label
        if (len > 1) {
          text += ' (+' + (len - 1) + ')'
        }
      }
    }
    return (
      <div>{text}</div>
    )
  }
}



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/Select/MultiSelectionRenderer.js